export default __webpack_public_path__ + "static/media/lut_control_dark_icon.0c108139.svg";